module.exports = __webpack_public_path__ + "static/08-e113d4cf0667b12c07cf4599181f8db6.jpg";